module.exports = __webpack_public_path__ + "media/images/logo_re-port-354ebd8d77d82d8493f80b9acb595030.png";